var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4667 19C8.57045 19 9.46576 18.1047 9.46576 17H5.46763C5.46763 18.1047 6.36295 19 7.4667 19ZM14.1976 14.3216C13.5939 13.6728 12.4642 12.6969 12.4642 9.5C12.4642 7.07188 10.7617 5.12812 8.46607 4.65125V4C8.46607 3.44781 8.01857 3 7.4667 3C6.91482 3 6.46732 3.44781 6.46732 4V4.65125C4.1717 5.12812 2.4692 7.07188 2.4692 9.5C2.4692 12.6969 1.33951 13.6728 0.735759 14.3216C0.548259 14.5231 0.465134 14.7641 0.466696 15C0.470134 15.5125 0.872321 16 1.46982 16H13.4636C14.0611 16 14.4636 15.5125 14.4667 15C14.4683 14.7641 14.3851 14.5228 14.1976 14.3216Z",
    fill: "#393949"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4667,
    cy: 5,
    r: 3.75,
    fill: "#E60000",
    stroke: "#F5F6F7",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NotificationIcon.27c478f2fd0951a9a0559ac5f3962fce.svg";